import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getPoolClusters } from "@/apis";
import { notification } from "antd";
import { requiredRule } from "./useBasicComponent";

export const usePoolConfig = (zone) => {
  const { t } = useTranslation();

  const [hadoopEnum, setHadoopEnum] = useState({});
  const [mysqlEnum, setMysqlEnum] = useState({});

  useEffect(() => {
    const getPools = async () => {
      try {
        const zones = Array.isArray(zone) ? zone : [zone];
        
        const results = await Promise.allSettled(
          zones.map(z => getPoolClusters(z))
        );

        let allHadoop = [];
        let allMysql = [];
        let hasError = false;

        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            const response = result.value;
            if (response.status === "OK") {
              allHadoop = [...allHadoop, ...response.value.hadoop];
              allMysql = [...allMysql, ...response.value.mysql];
            } else {
              hasError = true;
            }
          } else {
            hasError = true;
          }
        });

        const hadoopPool = allHadoop.reduce((acc, item) => {
          acc[item.id] = {
            text: `${item.name} (${item.usages}/${item.capacity}, ${item.nodegroup})`,
          };
          return acc;
        }, {});
        setHadoopEnum(hadoopPool);

        const mysqlPool = allMysql.reduce((acc, item) => {
          acc[item.id] = {
            text: `${item.name} (${item.usages}/${item.capacity}, ${item.nodegroup})`,
          };
          return acc;
        }, {});
        setMysqlEnum(mysqlPool);

        if (hasError) {
          const errorMsg = zones.length > 1 
            ? t("config.instance.error.pool.multi", "Failed to get pool clusters for some zones.") 
            : t("config.instance.error.pool", "Fail to get pool clusters list from server.");
          
          notification.error({ description: errorMsg });
        }
      } catch (error) {
        notification.error({
          description: t(
            "config.instance.error.pool",
            "Fail to get pool clusters list from server."
          ),
        });
        setHadoopEnum({});
        setMysqlEnum({});
      }
    };

    getPools();
  }, [zone]);

  const hint1 = "Select Hadoop/MySQL cluster from the pool.";
  const hint2 =
    "If not specify here, we will pick up one or create one for you.";

  const rawSchema = [
    {
      renderFormItem: () => {
        return (
          <div>
            <div>{t("config.instance.form.poolhint1", hint1)}</div>
            <div>{t("config.instance.form.poolhint2", hint2)}</div>
          </div>
        );
      },
      width: "m",
    },
    {
      title: t("config.instance.form.hadoop", "Hadoop"),
      dataIndex: "pool.hadoop",
      valueType: "select",
      valueEnum: hadoopEnum,
      width: "m",
    },
    {
      title: t("config.instance.form.mysql", "MySQL"),
      dataIndex: "pool.mysql",
      valueType: "select",
      valueEnum: mysqlEnum,
      width: "m",
    },
    {
      title: t(
        "config.instance.form.poolInfraSize",
        "Increase size of Hadoop Data node and Spark Worker node",
      ),
      dataIndex: `pool.size`,
      valueType: "digit",
      width: "m",
      initialValue: 0,
      formItemProps: {
        rules: [...requiredRule(t)],
      },
    },
  ];

  return rawSchema;
};
